import { useState } from "react";

export function usePictureUploadVM(imageUrl: string, onAction: (file?: File) => void) {
    const [file, setFile] = useState<File | undefined>(undefined);
    const [displayPicture, setDisplayPicture] = useState<any | undefined>(imageUrl);

    const onLoadFile = (event: HTMLInputElement) => {
        if (event.files && event.files.length > 0) {
            let file = event.files[0];
            setFile(file);
            onAction(file);
            loadDisplayPicture(file);
        }
    }

    const loadDisplayPicture = (file: File) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setDisplayPicture([reader.result]);
        };
    }

    const clearFileInput = () => {
        var oldInput = document.getElementById("uploadFile");

        var newInput = document.createElement("input");

        newInput.type = "file";
        newInput.id = "uploadFile";
        newInput.name = "uploadFile";
        newInput.onchange = (e: any) => onLoadFile(e.target);

        if (oldInput) {
            newInput.className = oldInput.className;
            newInput.style.cssText = oldInput.style.cssText;

            if (oldInput.parentNode) {
                oldInput.parentNode.replaceChild(newInput, oldInput);
            }
        }

        setFile(undefined);
        setDisplayPicture(undefined);
        onAction(undefined);
    }

    return {
        file,
        setFile,
        displayPicture,
        setDisplayPicture,

        onLoadFile,
        clearFileInput
    }
}